import { useContext } from 'react';
import { BaleProcessedContext } from './context';

export const useBaleProcessedContext = () => {
	const context = useContext(BaleProcessedContext);
	if (!context) {
		throw new Error('useBagScanContext must be used within a BagScanContextProvider');
	}
	return context;
};
